/* eslint-disable no-nested-ternary */
import React from 'react';
import './table.scss';
import PropTypes from 'prop-types';
import LoadingPlaceholder from 'components/loadingPlaceholder';
import Caret from 'components/caret';
import { TYPES } from 'envs';
import useResultProvider from 'dataProvider/hooks/useResultProvider';
import useFormatParties from '../../dataProvider/hooks/useFormatParties';
import { getSite } from '../../constants';
const excludes = [];
const TableCompareInsular = ({
  year,
  electionNumber,
  electionType,
  placeId,
  hideSeats,
  isSenate,
  showPerson,
  details,
  legend,
  type,
  resultOrigin,
  site,
  community,
  subtype
}) => {
  const { result: dataResult } = useResultProvider({
    active: resultOrigin.primary?.active,
    year,
    type,
    subtype,
    electionPlace: community,
    placeId,
    electionNumber,
    site
  });
  const { result: olDataResult } = useResultProvider({
    active: false /* buscame */,
    year: resultOrigin.historic?.year,
    electionPlace: community,
    type,
    subtype,
    placeId,
    electionNumber,
    site
  });
  const partyFormats = useFormatParties(
    dataResult,
    olDataResult,
    year,
    electionNumber,
    electionType,
    placeId,
    excludes,
    getSite()
  );

  if (!partyFormats || !olDataResult || !dataResult) {
    return <LoadingPlaceholder />;
  }
  const label = type === TYPES.MUNICIPAL ? 'Concejales' : 'Escaños';

  return (
    <div className="table-datosContainer">
      <div className="table-datosScroll">
        <div className="table-wrapper">
          {dataResult.length !== 0 && (
            <table
              summary={
                isSenate ? 'Senadores por partido' : 'Escaños por partido.'
              }
            >
              <thead>
                <tr>
                  <th className="partido">
                    {!showPerson ? 'Partido' : 'Representante'}
                  </th>
                  {!hideSeats && (
                    <th className="escanos">
                      {isSenate ? 'Senadores' : label}
                    </th>
                  )}
                  {details && <th className="porcentaje">%</th>}
                  {details && <th className="votos">Votos</th>}
                </tr>
              </thead>
              <tbody>
                {partyFormats &&
                  partyFormats.map(
                    item =>
                      item.votes !== undefined &&
                      item.votes > 0 && (
                        <tr key={item.name || item.partyAcronym || item.id}>
                          <td className="dato-nombre-partido">
                            <span
                              className="partido-color"
                              style={{
                                backgroundColor: item.partyColor
                              }}
                            />
                            <span className="partido">
                              {!showPerson
                                ? item.partyAcronym
                                : `${item.name} (${item.partyAcronym})`}
                            </span>
                          </td>
                          {!hideSeats && (
                            <td className="dato-escanos">
                              <span className="dato-seats">{item.seats}</span>
                              <Caret difference={item.difference} />
                            </td>
                          )}
                          {details && (
                            <td className="dato-escanos dato-escanos--percent">
                              {Number(item.votesPercent).toLocaleString('es')}
                            </td>
                          )}
                          {details && (
                            <td className="dato-escanos_votes">
                              {Number(item.votes).toLocaleString('de')}
                            </td>
                          )}
                        </tr>
                      )
                  )}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <div className="legendContainer">
        {legend &&
          legend.map(legendItem => (
            <p key={legendItem} className="table-datosLegend">
              {legendItem}
            </p>
          ))}
      </div>
    </div>
  );
};

TableCompareInsular.propTypes = {
  hideSeats: PropTypes.bool,
  isSenate: PropTypes.bool,
  legend: PropTypes.arrayOf(PropTypes.string),
  showPerson: PropTypes.bool,
  details: PropTypes.bool,
  year: PropTypes.string.isRequired,
  electionNumber: PropTypes.string.isRequired,
  electionType: PropTypes.string.isRequired,
  placeId: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  site: PropTypes.string.isRequired,
  community: PropTypes.string.isRequired,
  resultOrigin: PropTypes.shape({
    primary: PropTypes.shape({
      active: PropTypes.bool
    }),
    historic: PropTypes.shape({
      year: PropTypes.string
    })
  }).isRequired,
  subtype: PropTypes.string.isRequired
};

TableCompareInsular.defaultProps = {
  hideSeats: false,
  isSenate: false,
  showPerson: false,
  details: false,
  legend: null
};

export default TableCompareInsular;
